import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-card-mobile-skeleton',
  standalone: true,
  imports: [],
  templateUrl: './card-mobile-skeleton.component.html',
  styleUrl: './card-mobile-skeleton.component.css'
})
export class CardMobileSkeletonComponent implements OnInit {

  @Input()  qntdLinhas = 5;
  linhas: number[] = [];


  ngOnInit(): void {
    this.verificarQuantidadeLinhas();
  }

  verificarQuantidadeLinhas(){
    for(let i = 0; i < this.qntdLinhas; i++) {
      this.linhas.push(i + 1);
    }
  }

}
